import { Attention, Conseil, Info } from '@/design-system'

import { ExempleCalcul } from './ExempleCalcul'
import { TableauSeuils } from './TableauSeuils'

export const metadata = {
	title: 'The micro-BIC scheme',
	description: 'Understand the simplified tax scheme for small furnished rental landlords.'
}

# The micro-BIC scheme

The micro-BIC scheme (industrial and commercial profits) is a simplified tax scheme for furnished rental landlords whose income does not exceed certain ceilings.

## Income ceilings

<TableauSeuils />

<Attention>
Above these ceilings, you automatically switch to the actual expenses tax scheme.
</Attention>

## Advantages of the scheme

- **Simplicity**: no complex bookkeeping required
- **Simplified declaration**: a simple income declaration is enough
- **Automatic allowance**: expenses are deducted at a flat rate

<ExempleCalcul />

## Accounting obligations

- Keep an income ledger
- Keep supporting documents for 6 years
- Declare gross annual income

<Conseil>
Use rental management software or a simple spreadsheet to track your income throughout the year.
</Conseil>

## Switching to the actual expenses scheme

Switching to the actual expenses scheme is:

### Mandatory if:
- Your income exceeds the ceilings
- The activity is carried out through a company

### Optional if:
- Your actual expenses exceed the flat-rate allowance
- You want to carry a loss forward
- You want to recover VAT on renovation work

<Info>
The option for the actual expenses scheme is valid for a minimum of 2 years and is tacitly renewed for 2-year periods.
</Info>
